<li
  class="menu-item"
  [class.has-submenu]="hasSubmenu()"
  [class.expanded]="isExpanded()"
  [class.active-route]="isActiveRoute()"
  [class.has-active-child]="hasActiveChild()"
>
  <a
    [routerLink]="item().routerLink"
    [attr.href]="item().url"
    [target]="item().target"
    class="menu-link"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: routerLinkExact() }"
    (click)="toggleSubmenu($event)"
  >
    @if (item().icon) {
    <i [class]="item().icon"></i>
    } @if (!collapsed) {
    <span class="menu-label">{{ item().label | translate }}</span>
    } @if (hasSubmenu() && !collapsed) {
    <i
      class="submenu-icon pi"
      [ngClass]="isExpanded() ? 'pi-chevron-down' : 'pi-chevron-right'"
    ></i>
    }
  </a>

  @if (hasSubmenu() && isExpanded()) {
  <ul
    class="submenu"
    animate.enter="submenu-enter"
    animate.leave="submenu-leave"
  >
    @for (subItem of item().items; track subItem.label) {
    <app-menu-item [item]="subItem" [collapsed]="collapsed!"></app-menu-item>
    }
  </ul>
  }
</li>
